import { useMemo, useState } from "react";

/**
 * Owns every piece of state that's *about the uploaded files list* in the
 * workspace page (files collection, which one is active, which page is
 * showing, what's expanded, what's mid-split/pin/delete). Pulled out of
 * WorkspacePage.jsx in the iter-21 refactor so the page component can focus
 * on orchestration instead of book-keeping.
 *
 * The async handlers (split / pin / delete / rename / reorder) stay in the
 * page because they need to touch analyses + estimates state that live
 * alongside them. This hook just exposes the setters they mutate.
 */
export function useWorkspaceUploads() {
    const [files, setFiles] = useState([]);
    const [activeFileId, setActiveFileId] = useState(null);
    const [activePage, setActivePage] = useState(1);
    const [expandedPdfs, setExpandedPdfs] = useState(() => new Set());
    const [uploadOpen, setUploadOpen] = useState(false);
    const [pendingDeleteFile, setPendingDeleteFile] = useState(null);
    const [deletingFile, setDeletingFile] = useState(false);
    const [splittingIds, setSplittingIds] = useState(() => new Set());
    const [pinningSubpage, setPinningSubpage] = useState({
        fileId: null,
        page: null,
    });

    const activeFile = useMemo(
        () => files.find((f) => f.id === activeFileId) || files[0] || null,
        [files, activeFileId],
    );

    return {
        // list
        files,
        setFiles,
        // selection
        activeFileId,
        setActiveFileId,
        activeFile,
        activePage,
        setActivePage,
        // expansion / progress UI
        expandedPdfs,
        setExpandedPdfs,
        splittingIds,
        setSplittingIds,
        pinningSubpage,
        setPinningSubpage,
        // modals
        uploadOpen,
        setUploadOpen,
        pendingDeleteFile,
        setPendingDeleteFile,
        deletingFile,
        setDeletingFile,
    };
}
